import React, { useEffect } from "react";
import { Api } from "../../api";
import {
  TextField,
  InputAdornment,
  IconButton,
  List,
  ListItem,
  makeStyles,
  createStyles,
  Theme,
  Checkbox,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/SearchOutlined";
import ClearIcon from "@material-ui/icons/Clear";
import { Training } from "../../types/Training";
import { hasError } from "../../helpers/ResponseHelper";

interface IProps {
  companyId: string;
  selectedTrainingIds: string[];
  onTrainingSelected: (training: Training) => void;
  selectAllTraining?: boolean;
  onSelectallTrainings?: (trainings: Array<Training>) => void;
}

export default function TrainingPicker(props: IProps) {
  const { companyId, selectedTrainingIds, onTrainingSelected, selectAllTraining, onSelectallTrainings } = props;
  const [training, setTraining] = React.useState(Array<Training>());
  const [filtered, setFiltered] = React.useState(Array<Training>());
  const [searchText, setSearchText] = React.useState("");
  const classes = useStyles();

  useEffect(() => {
    if (companyId) {
      Api.training.getPublishedByCompany(companyId).then((result) => {
        if (!hasError(result)) {
          const data = result?.data?.data ?? [];
          data
            .sort((a, b) =>
              a.trainingTitle
                .toLocaleUpperCase()
                .localeCompare(b.trainingTitle.toLocaleUpperCase())
            )
            .filter((t) => t.active);
          setTraining(data);
        }
      });
    }
  }, [companyId]);

  useEffect(() => {
    if (selectAllTraining) {
      if (onSelectallTrainings) {
        onSelectallTrainings(filtered)
      }
    }
    // eslint-disable-next-line  
  }, [filtered, selectAllTraining])

  useEffect(() => {
    if (searchText) {
      let f = training
        .filter((t) => {
          return (
            t.trainingTitle
              .toLocaleUpperCase()
              .indexOf(searchText.toLocaleUpperCase()) > -1
          );
        })
        .sort((a, b) =>
          a.trainingTitle
            .toLocaleUpperCase()
            .localeCompare(b.trainingTitle.toLocaleUpperCase())
        );
      setFiltered(f);
    } else {
      setFiltered(training);
    }
    console.log(searchText);
  }, [searchText, training]);

  // function searchChanged();

  return (
    <>
      <TextField
        fullWidth
        variant="outlined"
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                disabled={!searchText}
                onClick={() => setSearchText("")}
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        className="tableSearch"
      />
      <div className="picker-content">
        <List className={(classes.listRoot, "picker")}>
          {filtered.map((t) => (
            <ListItem key={t.trainingId}>
              <Checkbox
                edge="start"
                checked={selectedTrainingIds.indexOf(t.trainingId) !== -1}
                tabIndex={-1}
                disableRipple
                onClick={() => onTrainingSelected(t)}
              />
              <div
                className={classes.textContainer}
                onClick={() => onTrainingSelected(t)}
              >
                <div className={classes.trainingTitle}>{t.trainingTitle}</div>
                <div className={classes.trainingDesc}>{t.trainingDesc}</div>
              </div>
            </ListItem>
          ))}
        </List>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listRoot: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      position: "relative",
      overflow: "auto",
      maxHeight: 300,
    },
    trainingTitle: {
      textTransform: "uppercase",
      fontSize: 16,
      color: "#222223",
    },
    trainingDesc: {
      fontSize: 11,
      color: "#222223",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "350px",
    },
    textContainer: {
      cursor: "pointer",
      flex: 1,
    },
  })
);
